export default __webpack_public_path__ + "static/media/multiDataset.c809e2df.svg";